import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationService} from '../../services/authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.html',
  styleUrls: ['./login.scss']
})
export class LoginComponent implements OnInit {
  public model: any = {};
  public error = '';

  constructor(private _router: Router, private _authenticationService: AuthenticationService) {
  }

  public ngOnInit() {
    // reset login status
    this._authenticationService.logout();
  }

  public login() {
    this._authenticationService.login(this.model.username, this.model.password)
      .subscribe(result => {
        this._router.navigate(['/']);
      }, error => {
        this.error = 'Username or password is incorrect';
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.ts